// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScanProfileSettingsSchema } from './ScanProfileSettingsSchema'
import type { ScanProfileSettings } from './ScanProfileSettingsSchema'
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { ScanProfileSchema } from './ScanProfileSchema';

/////////////////////////////////////////
// SCAN PROFILE RELATION SCHEMA
/////////////////////////////////////////

export type ScanProfileRelations = {
  settings: ScanProfileSettings;
  surfaces: ExternalNetworkWithRelations[];
};

export type ScanProfileWithRelations = z.infer<typeof ScanProfileSchema> & ScanProfileRelations

export const ScanProfileWithRelationsSchema: z.ZodType<ScanProfileWithRelations> = ScanProfileSchema.merge(z.object({
  settings: z.lazy(() => ScanProfileSettingsSchema),
  surfaces: z.lazy(() => ExternalNetworkWithRelationsSchema).array(),
}))